"use strict";import{Textfield as e}from"./src/Textfield.js";customElements.define("sp-textfield",e);
//# sourceMappingURL=sp-textfield.js.map
